import type { CSSProperties, HTMLAttributes } from 'react'
import mascotImage from '@/assets/images/reg.jpg'
import { cn } from '@/shared/lib/utils'

const gleamBrandTextureStyle: CSSProperties = {
  backgroundImage:
    'url(https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExaTh6bWtiM3Z4bDdrNmoxb3Fqdjh4cTFmbWh6YzV3MDBnOHp6ZmMzciZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/l4JzaNFEqXp0vOSgE/giphy.gif)',
  backgroundSize: 'cover',
  color: 'transparent',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
}

type GleamWordmarkProps = HTMLAttributes<HTMLSpanElement>

export function GleamWordmark({ className, style, ...props }: GleamWordmarkProps) {
  return (
    <span
      className={cn(
        'font-logo font-black uppercase leading-none tracking-[0.16em] drop-shadow-[0_0_18px_rgba(255,92,192,0.35)]',
        className,
      )}
      style={{ ...gleamBrandTextureStyle, ...style }}
      {...props}
    >
      gleam
    </span>
  )
}

interface GleamMascotBackdropProps extends HTMLAttributes<HTMLDivElement> {
  imageClassName?: string
  gradientClassName?: string
  withLeftFade?: boolean
}

export function GleamMascotBackdrop({
  className,
  imageClassName,
  gradientClassName,
  withLeftFade = true,
  ...props
}: GleamMascotBackdropProps) {
  return (
    <div
      className={cn('pointer-events-none absolute inset-0 overflow-hidden', className)}
      aria-hidden="true"
      {...props}
    >
      <img
        src={mascotImage}
        alt=""
        className={cn('absolute inset-0 size-full object-cover object-right', imageClassName)}
        loading="lazy"
      />
      <div
        className={cn(
          'absolute inset-0 bg-gradient-to-bl from-surface via-surface/75 to-surface/10',
          gradientClassName,
        )}
      />
      {withLeftFade ? (
        <div className="absolute inset-y-0 left-0 hidden w-1/2 bg-gradient-to-r from-surface via-surface/90 to-transparent lg:block" />
      ) : null}
    </div>
  )
}
